import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email'),
  password: z.string().min(1, 'Password is required'),
})

export type LoginFormValues = z.infer<typeof loginSchema>

export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email'),
})

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>

export const registerSchema = z
  .object({
    email: z.string().min(1, 'Email is required').email('Please enter a valid email'),
    first_name: z.string().min(1, 'First name is required'),
    last_name: z.string().min(1, 'Last name is required'),
    password: z.string().min(1, 'Password is required'),
    confirm_password: z.string().min(1, 'Please confirm your password'),
    business_unit: z.string().min(1, 'Business unit is required'),
    business_role: z.string().min(1, 'Business role is required'),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: 'Passwords do not match',
    path: ['confirm_password'],
  })

export type RegisterFormValues = z.infer<typeof registerSchema>
